import * as React from 'react';
// import { Link } from 'react-router-dom';
import { NavItem, NavLink } from 'reactstrap';
import * as Scroll from 'react-scroll';

import './NavLink.css';

type props = {
  value: string,
  path: string,
  desc?: string
  type: 'nav'|'hero',
  index?: number
};

export class NavButton extends React.Component<props, {}> {

  render() {
    switch(this.props.type) {
      case 'nav':
        return (
          <NavItem>
            <NavLink>
              <Scroll.Link
                to={this.props.path}

                smooth="easeOutQuint"
                offset={ this.props.index ? -50 : 0 }
                duration={600}
                isDynamic={true}
                ignoreCancelEvents={false} >
                {this.props.value}
              </Scroll.Link>
            </NavLink>
          </NavItem>
        );
      case 'hero':
        return (
              <Scroll.Link
                to={this.props.path}
                className="nav-button"  
                smooth="easeOutQuint"
                offset={ this.props.index ? -50 : 0 }
                duration={600}
                isDynamic={true}
                ignoreCancelEvents={false} >
                            <span>{this.props.value}</span>
            <span className="nav-link-desc">{this.props.desc}</span>
              </Scroll.Link>
        );
      default:
        return null;
    }

  }
}
/*
          <Link to={'#' + this.props.path} className="nav-button"  data-wow-delay={ 0.3 + ( typeof this.props.index === 'number' ? ( this.props.index + 1 ) / 10 : 0 ) + "s" }>
            <span>{this.props.value}</span>
            <span className="nav-link-desc">{this.props.desc}</span>
          </Link>
*/


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/nav-link/NavLink.tsx